import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Popup from "reactjs-popup";
import { formatError } from './../helpers'
import { Button } from 'reactstrap';

class PopupError extends React.Component {

    render() {
        const deactivateCurrent = 'DeactivateCurrent';
        const deactivateOthers = 'DeactivateOthers';
        const errorCodeToCheck = 7;
        let productIsActive = false;
        if (this.props.errors) {
            productIsActive = this.props.errors.some(error => error.errorCode === errorCodeToCheck);
        }
        return (
            <Popup
                trigger={null}
                modal
                closeOnDocumentClick
                open={this.props.open}
                onClose={this.props.onClose}>
                <div>
                    <button type="button" onClick={this.props.onClick} className="close text-danger" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div><FontAwesomeIcon icon="exclamation-triangle" size="sm" color={this.props.isWarning ? '#FFB703' : 'red'} />
                        <strong> {this.props.isWarning ? 'Warning!' : 'Error!'}</strong>
                        <ul>
                            {this.props.errorMessage.map((errors, index) => {
                                return <li key={index}>{formatError(errors)}</li>
                            }
                            )}
                            {productIsActive &&
                                <div>
                                    <p>Deactivate that product - or set this new product to Inactive?</p>
                                    <Button onClick={(e) => this.props.onSubmit(e, deactivateOthers)} type="submit" className='mx-2 cancel-btn' style={{ marginTop: 0, width: 200 }}>Deactivate other product</Button>
                                    <Button onClick={(e) => this.props.onSubmit(e, deactivateCurrent)} type="submit" className='mx-2 cancel-btn' style={{ marginTop: 0, width: 200 }}>Deactivate this product</Button>
                                </div>
                            }
                        </ul>
                    </div>
                </div>
            </Popup>);
    }
}

export default PopupError;